import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-library',
  template: `
    <p>
      library works!
    </p>
  `,
  styles: []
})
export class LibraryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
